export interface AttachmentCategoryOption {
  id: string;
  name: string;
}

export const ATTACHMENT_CATEGORIES: AttachmentCategoryOption[] = [
  { id: 'informe_gestion', name: 'Informe de gestión' },
  { id: 'avenimiento', name: 'Avenimiento, conciliación o transacción' },
  { id: 'antecedentes_asignacion', name: 'Antecedentes de asignación' },
  { id: 'escritos_resoluciones', name: 'Escritos y resoluciones judiciales' },
  { id: 'otro', name: 'Otro' },
];

const LABEL_BY_ID = ATTACHMENT_CATEGORIES.reduce<Record<string, string>>((acc, item) => {
  acc[item.id] = item.name;
  return acc;
}, {});

export function attachmentCategoryLabel(category?: string | null, categoryother?: string | null): string {
  if (!category) {
    return '';
  }
  if (category === 'otro') {
    const other = (categoryother || '').trim();
    return other ? `Otro: ${other}` : 'Otro';
  }
  return LABEL_BY_ID[category] || category;
}

export function attachmentCategoryCssClass(category?: string | null): string {
  if (!category) {
    return '';
  }
  return `attachment-category--${category}`;
}

export function isAttachmentCategoryComplete(file: {
  category?: string | null;
  categoryother?: string | null;
}): boolean {
  if (!file?.category) {
    return false;
  }
  if (file.category === 'otro') {
    return !!(file.categoryother && String(file.categoryother).trim());
  }
  return true;
}
